export default "__VITE_ASSET__Go3Y8MMS__"